// store/index.js
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './rootReducer'; 

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'] // 必须与 combineReducers 键名一致
};

const persistedReducer = persistReducer(persistConfig, rootReducer); // 正确引用

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({ serializableCheck: false }) // 禁用序列化警告
});

export const persistor = persistStore(store);
